import { LocationStrategy } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Options } from 'focus-trap';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx';
import { getItemMenuButtonSelector } from '®app/shared/focus';
import { AppConfig } from '®shared/config';
import { UriService } from '®shared/url-utils';

import { HideShareSheetModalAction } from './share-sheet.actions';
import { ShareSheetState, selectShareSheetState } from './share-sheet.state';

@Component({
  selector: 'rl-share-sheet-modal',
  templateUrl: './share-sheet-modal.component.html',
})
export class ShareSheetModalComponent implements OnDestroy, OnInit {
  @ViewChild('shareSheetModal', { static: true })
  public shareSheetModal: ModalDirective;

  state: ShareSheetState;

  private shareSheetStateSubscription: Subscription;
  private shortCode = this.appConfig.tenant.shortCode;

  public copyStatus = false;
  public shareUrl: string;

  constructor(
    private appConfig: AppConfig,
    private locationStrategy: LocationStrategy,
    private store: Store<State>,
    private uriService: UriService,
  ) {}

  ngOnInit() {
    this.shareSheetStateSubscription = this.store
      .select(selectShareSheetState)
      .subscribe(state => {
        this.state = state;

        if (this.state.currentItem) {
          this.shareUrl = this.uriService.getItemShareUrl(
            this.locationStrategy.getBaseHref(),
            this.shortCode,
            this.state.currentItem.id,
          );
          this.shareSheetModal.show();
        } else {
          this.shareSheetModal.hide();
        }
      });
  }

  ngOnDestroy() {
    if (this.shareSheetStateSubscription) {
      this.shareSheetStateSubscription.unsubscribe();
    }
  }

  get focusTrapConfig(): Options {
    if (!this.state || !this.state.currentItem) {
      return {};
    }

    const setReturnFocus = getItemMenuButtonSelector(this.state.currentItem.id);
    return { setReturnFocus };
  }

  onShareSheetHidden() {
    this.store.dispatch(new HideShareSheetModalAction());
  }

  onHideShareSheet() {
    this.store.dispatch(new HideShareSheetModalAction());
  }

  setCopied() {
    this.copyStatus = true;
  }
}
